/**
 * 회원상태
 *
 * @param NORMAL 정상
 * @param BIZ_REQ 기업신청
 * @param BIZ_REJECT 기업신청거절
 * @param SLEEP 휴면
 * @param WITHDRAWAL 탈퇴
 */
export const MBR_STATUS = {
  // 회원상태
  /** @property {string} 정상 */
  NORMAL: '00001',
  /** @property {string} 기업신청 */
  BIZ_REQ: '00002',
  /** @property {string} 기업신청거절 */
  BIZ_REJECT: '00003',
  /** @property {string} 휴면 */
  SLEEP: '00004',
  /** @property {string} 탈퇴 */
  WITHDRAWAL: '00005',
};
/**
 * 회원타입
 *
 * @param NORMAL 일반회원
 * @param BIZ 기업회원
 */
export const MEM_TYPE = {
  /** @property {string} 일반회원 */
  NORMAL: 'U',
  /** @property {string} 기업회원 */
  BIZ: 'C',
};
/**
 * 회원등급
 *
 * @param NORMAL 일반회원
 * @param CREATOR 크리에이터
 */
export const MEM_GRADE = {
  /** @property {string} 일반회원 */
  NORMAL: 'U',
  /** @property {string} 크리에이터 */
  CREATOR: 'C',
};
/**
 * SNS타입
 *
 * @param NORMAL 일반
 * @param KAKAO 카카오
 * @param GOOGLE 카카오
 */
export const SNS_TYPE = {
  /** @property {string} 일반 */
  NORMAL: 'B',
  /** @property {string} 카카오 */
  KAKAO: 'K',
  /** @property {string} 구글 */
  GOOGLE: 'G',
};
/**
 * 가입경로
 *
 * @param REQ_TOTAL 연동가입(송신)
 * @param RES_TOTAL 연동가입(수신)
 * @param SINGLE_JOIN 단독가입
 */
export const JOIN_PATH = {
  /** @property {string} 연동가입(송신) */
  REQ_TOTAL: '00001',
  /** @property {string} 연동가입(수신) */
  RES_TOTAL: '00002',
  /** @property {string} 단독가입 */
  SINGLE_JOIN: '00003',
};
/**
 * 거래유형(내부거래)
 *
 * @param DEPOSIT 내부입금
 * @param WITHDRAWAL 내부출금
 * @param NFT_DEPOSIT NFT입금
 * @param NFT_WITHDRAWAL NFT출금
 * @param FEE_DEPOSIT 수수료입금
 * @param FEE_WITHDRAWAL 수수료출금
 */
export const TRANS_IN_TYPE = {
  /** @property {string} 내부입금 */
  DEPOSIT: '00001',
  /** @property {string} 내부출금 */
  WITHDRAWAL: '00002',
  /** @property {string} NFT입금 */
  NFT_DEPOSIT: '00003',
  /** @property {string} NFT출금 */
  NFT_WITHDRAWAL: '00004',
  /** @property {string} 수수료입금 */
  FEE_DEPOSIT: '00005',
  /** @property {string} 수수료출금 */
  FEE_WITHDRAWAL: '00006',
};
/**
 * 거래유형(외부거래)
 *
 * @param DEPOSIT 내부입금
 * @param WITHDRAWAL 내부출금
 * @param GATHERING 집금
 * @param FEE_DEPOSIT 수수료주소입금
 * @param FEE_WITHDRAWAL 수수료주소출금
 * @param NFT_DEPLOYMENT NFT 컨트랙트 배포
 * @param NFT_ITEM_CREATION NFT아이템발행
 * @param NFT_DEPOSIT NFT입금
 * @param NFT_WITHDRAWAL NFT출금
 */
export const TRANS_OUT_TYPE = {
  /** @property {string} 내부입금 */
  DEPOSIT: '00001',
  /** @property {string} 내부출금 */
  WITHDRAWAL: '00002',
  /** @property {string} 집금 */
  GATHERING: '00003',
  /** @property {string} 수수료주소입금 */
  FEE_DEPOSIT: '00004',
  /** @property {string} 수수료주소출금 */
  FEE_WITHDRAWAL: '00005',
  /** @property {string} NFT 컨트랙트 배포 */
  NFT_DEPLOYMENT: '00006',
  /** @property {string} NFT아이템발행 */
  NFT_ITEM_CREATION: '00007',
  /** @property {string} NFT입금 */
  NFT_DEPOSIT: '00008',
  /** @property {string} NFT출금 */
  NFT_WITHDRAWAL: '00009',
};
/**
 * 거래상태
 *
 * @param PENDING 진행중
 * @param UNFINALIZED 미완료
 * @param FINALIZED 완료
 * @param FAILED 트랜잭션 실패
 */
export const TRANS_STATUS = {
  /** @property {string} 진행중 */
  PENDING: '00001',
  /** @property {string} 미완료 */
  UNFINALIZED: '00002',
  /** @property {string} 완료 */
  FINALIZED: '00003',
  /** @property {string} 트랜잭션 실패 */
  FAILED: '00004',
};
/**
 * 출금승인상태
 *
 * @param REQ 신청
 * @param REQ_ING 승인/거절 진행중
 * @param WAIT 출금대기
 * @param REJECT 출금거절
 * @param COMPLETE 신청완료
 * @param GAS_FEE 가스비출금신청
 */
export const WDR_STATUS = {
  /** @property {string} 신청 */
  REQ: '00001',
  /** @property {string} 승인/거절 진행중 */
  REQ_ING: '00002',
  /** @property {string} 출금대기 */
  WAIT: '00003',
  /** @property {string} 출금거절 */
  REJECT: '00004',
  /** @property {string} 신청완료 */
  COMPLETE: '00005',
  /** @property {string} 가스비출금신청 */
  GAS_FEE: '00006',
};
/**
 * 게시판형태
 *
 * @param NOTICE 공지사항
 * @param FAQ FAQ
 * @param INQUIRY 1:1문의
 */
export const BOARD_TYPE = {
  /** @property {string} 공지사항 */
  NOTICE: '00001',
  /** @property {string} FAQ */
  FAQ: '00002',
  /** @property {string} 1:1문의 */
  INQUIRY: '00003',
};
/**
 * 약관유형
 *
 * @param SERVICE 서비스이용약관
 * @param PERSON 개인정보수집이용동의
 * @param MARKETING 혜택 및 마케팅 수신동의
 * @param TRANSFER_AGREEMENT 양수도 계약
 */
export const TERMS_TYPE = {
  /** @property {string} 서비스이용약관 */
  SERVICE: '00001',
  /** @property {string} 개인정보수집이용동의 */
  PERSON: '00002',
  /** @property {string} 혜택 및 마케팅 수신동의 */
  MARKETING: '00003',
  /** @property {string} 양수도 계약 */
  TRANSFER_AGREEMENT: '00004',
  /** @property {string} 소유자 권리 */
  OWNER_RIGHT: '00005',
  /** @property {string} 청약철회 및 환불 */
  REFUND: '00006',
  /** @property {string} 개신정보수집이용동의(고유식별번호) */
  IDENTIFICATION: '00007',
  /** @property {string} 개인정보수집이용동의(수집이용동의) */
  COLLECTION: '00008',
  /** @property {string} 스카이런 개인정보수집이용동의 */
  SKYRUN_PERSON: '00009',
  /** @property {string} 자이언츠 개인정보수집이용동의 */
  GIANTS_PERSON: '00010',
  /** @property {string} DDP 개인정보 제3자 제공 동의 */
  DDP_PERSON: '00011',
  /** @property {string} FC안양 개인정보 제3자 제공 동의 */
  FC_ANYANG_PRE_EVENT_PERSON: '00012',
  /** @property {string} 수원삼성 개인정보 제3자 제공 동의 */
  SUWON_BLUEWINGS_PRE_EVENT_PERSON: '00013',
  /** @property {string} 아이브 개인정보 제3자 제공 동의 */
  IVE_PERSON: '00014',
  /** @property {string} 니울 개인정보 제3자 제공 동의 */
  NIUL_AI_PERSON: '00015',
  /** @property {string} 니울 개인정보 수집이용 동의 */
  ITTA_MAGAZINE_PRIVACY: '00016',
  /** @property {string} 니울 개인정보 제3자 제공 동의 */
  ITTA_MAGAZINE_THIRD_PARTY: '00017',
  /** @property {string} 정기결제 이용약관 */
  RECURRING_PAYMENT: '00019',
};
/**
 * 배포상태
 *
 * @param REQUEST 신청
 * @param COMPLETE 완료
 * @param FAIL 실패
 */
export const DEPLOY_STATUS = {
  /** @property {string} 신청 */
  REQUEST: '00001',
  /** @property {string} 완료 */
  COMPLETE: '00002',
  /** @property {string} 실패 */
  FAIL: '00003',
};
/**
 * 크리에이터 상태코드
 *
 * @param REQUEST 신청
 * @param WAIT 대기
 * @param CANCEL 취소
 * @param ACCEPT 승인
 * @param REJECT 거부
 */
export const CREATOR_STATUS = {
  /** @property {string} 신청 */
  REQUEST: '00001',
  /** @property {string} 대기 */
  WAIT: '00002',
  /** @property {string} 취소 */
  CANCEL: '00003',
  /** @property {string} 승인 */
  ACCEPT: '00004',
  /** @property {string} 거부 */
  REJECT: '00005',
};
/**
 * 판매 유형 코드
 *
 * @param BUY_NOW 즉시판매
 * @param AUCTION 경매
 * @param AIRDROP 에어드랍
 */
export const SELL_TYPE = {
  /** @property {string} 즉시판매 */
  BUY_NOW: '00001',
  /** @property {string} 경매 */
  AUCTION: '00002',
  /** @property {string} 에어드랍 */
  AIRDROP: '00003',
};
/**
 * 판매 상태코드
 *
 * @param WAIT 대기중
 * @param TO_BE_SALE 판매예정
 * @param SALEING 판매중
 * @param SALE_END 판매종료
 * @param SALE_CANCEL 판매취소
 */
export const SELL_STATUS = {
  /** @property {string} 대기중 */
  WAIT: '00000',
  /** @property {string} 판매예정 */
  TO_BE_SALE: '00001',
  /** @property {string} 판매중 */
  SALEING: '00002',
  /** @property {string} 판매종료 */
  SALE_END: '00003',
  /** @property {string} 판매취소 */
  SALE_CANCEL: '00004',
};
/**
 * 거래 유형 코드
 *
 * @param BUY_NOW 즉시판매
 * @param AUCTION 경매
 * @param AIRDROP 에어드랍
 * @param REQ_BUY 가격제안
 * @param PUBLISH 발행
 */
export const TRANS_CODE = {
  /** @property {string} 즉시판매 */
  BUY_NOW: '00001',
  /** @property {string} 경매 */
  AUCTION: '00002',
  /** @property {string} 에어드랍 */
  AIRDROP: '00003',
  /** @property {string} 가격제안 */
  REQ_BUY: '00004',
  /** @property {string} 발행 */
  PUBLISH: '00005',
};
/**
 * 발행 상태 코드
 *
 * @param REQUEST 신청
 * @param WAIT 대기
 * @param COMPLETE 완료
 * @param FAIL 실패
 */
export const PUBLISH_STATUS = {
  /** @property {string} 신청 */
  REQUEST: '00001',
  /** @property {string} 대기 */
  WAIT: '00002',
  /** @property {string} 완료 */
  COMPLETE: '00003',
  /** @property {string} 실패 */
  FAIL: '00004',
};
/**
 * 제안 상태 코드
 *
 * @param REQUEST 신청
 * @param REJECT 거절
 * @param ACCEPT 승인
 * @param CANCEL 취소
 */
export const PROPOSAL_STATUS = {
  /** @property {string} 신청 */
  REQUEST: '00001',
  /** @property {string} 거절 */
  REJECT: '00002',
  /** @property {string} 승인 */
  ACCEPT: '00003',
  /** @property {string} 취소 */
  CANCEL: '00004',
};
/**
 * 경매 상태 코드
 *
 * @param REQUEST 신청
 * @param REJECT 거절
 * @param ACCEPT 승인
 * @param CANCEL 취소
 * @param UPPER 상위입찰
 */
export const AUCTION_STATUS = {
  /** @property {string} 신청 */
  REQUEST: '00001',
  /** @property {string} 거절 */
  REJECT: '00002',
  /** @property {string} 승인 */
  ACCEPT: '00003',
  /** @property {string} 취소 */
  CANCEL: '00004',
  /** @property {string} 상위입찰 */
  UPPER: '00005',
};

/**
 * 알림 타입
 *
 * @param DEPOSIT 입금
 * @param WITHDRAWAL 출금
 */
export const ALRM_TYPE = {
  /** @property {string} 입금*/
  DEPOSIT: '00001',
  /** @property {string} 출금*/
  WITHDRAWAL: '00002',
};

/**
 * 거래 서브 타입
 *
 * @param PRICE 판매대금
 * @param SELL_FEE 판매수수료
 * @param ROYALTY 로얄티
 * @param GAS_FEE 가스비
 */
export const TRANS_SUB_TYPE = {
  /** @property {string} 입금*/
  PRICE: '00001',
  /** @property {string} 판매수수료*/
  SELL_FEE: '00002',
  /** @property {string} 로얄티*/
  ROYALTY: '00003',
  /** @property {string} 가스비*/
  GAS_FEE: '00004',
};

/**
 * 대량 발행 NFT 상태 코드
 *
 * @param REQUEST 신청
 * @param WAIT 대기
 * @param COMPLETE 완료
 * @param FAIL 실패
 */
export const BULK_PUBLISH_STATUS = {
  /** @property {string} 신청 */
  CREATED: '00001',
  /** @property {string} 대기 */
  REQUESTED: '00002',
  /** @property {string} 완료 */
  COMPLETE: '00003',
  /** @property {string} 실패 */
  FAIL: '00004',
};

/**
 * 대량 NFT 에어드랍 상태 코드
 *
 * @param REQUEST 신청
 * @param WAIT 대기
 * @param COMPLETE 완료
 * @param FAIL 실패
 */
export const BULK_AIRDROP_NFT_STATUS = {
  /** @property {string} 신청 */
  CREATED: '00001',
  /** @property {string} 대기 */
  REQUESTED: '00002',
  /** @property {string} 완료 */
  COMPLETE: '00003',
  /** @property {string} 실패 */
  FAIL: '00004',
};
/**
 * 양수도 계약 상태 코드
 *
 * @param Sign_Transferor 양도자 사인
 * @param Sign_Transferee 양수자 사인
 * @param CLOSE 계약 종료
 */
export const TRANSFER_AGREEMENT_STATUS = {
  Sign_Transferor: 'S01',
  Sign_Transferee: 'S02',
  CLOSE: 'S03',
};

/**
 * 컬렉션 카테고리 타입
 * (양수도 계약서 구분을 위해 사용되며, 리팩토링 예정)
 *
 * @param PFP PFP
 * @param DIGITAL_ART DIGITAL_ART
 */
export const CONTRACT_CATEGORY_TYPE = {
  /** @property {string} PFP */
  PFP: 'NT001',
  /** @property {string} DIGITAL_ART */
  DIGITAL_ART: 'NT007',
};

export const MINOR_EXCEPTION_FAIL_STATUS = '4999';

// 외국인 예외처리 status
export const FOREIGNER_EXCEPTION_FAIL_STATUS = '4997';
/**
 * 약관 처리 상수
 *
 * @param PROVISION 서비스이용약관
 * @param PRIVACY 개인정보이용약관
 * @param MARKETING 마케팅이용약관
 */
export enum TERMS_FIELD {
  /** @property {string} 서비스이용약관 */
  PROVISION = 'provision',
  /** @property {string} 개인정보이용약관 */
  PRIVACY = 'privacy',
  /** @property {string} 마케팅이용약관 */
  MARKETING = 'marketing',
}

/**
 * NFT 입력 필드
 *
 * @param DEPOLY_QTY 발행개수
 * @param TOKEN_ID 토큰아이디
 * @param NFT_DESC NFT 상세
 * @param COLLECTION_SEQ 컬렉션
 * @param NFT_NM NFT 명
 */
export enum NFT_INPUT_FIELD {
  /** @property {string} 발행개수 */
  DEPOLY_QTY = 'depoly_qty',
  /** @property {string} 토큰아이디 */
  TOKEN_ID = 'token_id',
  /** @property {string} NFT 상세 */
  NFT_DESC = 'nft_desc',
  /** @property {string} 컬렉션 */
  COLLECTION_SEQ = 'collection_seq',
  /** @property {string} NFT 명 */
  NFT_NM = 'nft_nm',
}
